import styled, { keyframes } from "styled-components";

export interface InitializingProps {}

const placeHolderShimmer = keyframes`
  0% {
      background-position: -468px 0
  }
  100% {
      background-position: 468px 0
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
`;

export const EmptyBackgroundAnimation = styled.span`
  display: block;
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: linear;
  background: #f7efdd;
  background: linear-gradient(to right, #f7efdd 8%, #efe4cf 18%, #f7efdd 33%);
  background-size: 1024px 104px;
  position: relative;
  border-radius: 8px;
`;

const EmptyQR = styled(EmptyBackgroundAnimation)`
  width: 100%;
  height: 100%;
`;

const EmptyQrWrap = styled.div`
  width: 200px;
  height: 200px;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0;
`;

export default function Initializing(_: InitializingProps): JSX.Element {
  return (
    <Container>
      <EmptyQrWrap>
        <EmptyQR data-testid="authentication_loading" />
      </EmptyQrWrap>
    </Container>
  );
}
